import { Input } from 'antd';
import React, { useState } from 'react';
export const GraphConfigEditor = ({ onChange, value }) => {
    const [isValid, setIsValid] = useState(true);
    return React.createElement(Input.TextArea, { autoSize: true, defaultValue: JSON.stringify(value)
            .replaceAll('{', '{\r\n\t')
            .replaceAll(',"', ',\r\n\t"')
            .replaceAll('}', '\r\n}'), onChange: (e) => {
            try {
                const result = JSON.parse(e.target.value);
                setIsValid(true);
                onChange(result);
            }
            catch (ex) {
                setIsValid(false);
                console.log(ex);
            }
        }, spellCheck: false, status: isValid ? undefined : 'error' });
};
